import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, snap the window scroll back to the top so users
 * don't land halfway down a new page. React Router doesn't do this by default
 * — SPAs inherit the previous route's scroll position without an explicit reset.
 *
 * We use `behavior: "auto"` (not "smooth") on purpose — smooth scroll during
 * navigation feels laggy on long pages and can confuse screen readers.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
